import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class TimeSlotActions extends Actions{
    static get target(){
        return 'timeSlots'
    }
}


// WEBPACK FOOTER //
// ./actions/TimeSlotActions.js